import Axios from 'axios';
import { config } from '../../config/Constants';

export const getBlobFiles = (companyName, pagingParams = {}) =>
  Axios.get(config.url.GET_DOWNLOAD_CENTER_FILES, {
    params: {
      companyName,
      ...(pagingParams.folderName ? { folderName: pagingParams.folderName } : {}),
      ...(pagingParams.continuationToken ? { continuationToken: pagingParams.continuationToken } : {}),
    }
  });

export const getBlobFile = (fileName) =>
  Axios.get(config.url.GET_BLOB_FILE, {
    params: { fileName },
    responseType: 'arraybuffer',
  });
